import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { sortHumanReadable } from '@iotv/datamodel-core';
import { ComparisonType } from '@iotv/iotv-v3-types';
import { FormControl, InputLabel, MenuItem, Select, Toolbar } from '@mui/material';
import { useEffect, useState } from 'react';
import { getItemsByType } from '../../../../data/Wideawake/wideawakeDataFns';
export const TypeByParent = (props) => {
    const { updateParams: setParamsInParent, index, keyPress, supportKey, attKey, filter, children, selected } = props;
    const [parents, setParents] = useState();
    const [selectedContext, setSelectedContext] = useState();
    useEffect(() => {
        getItemsByType(attKey).then((resultPromise) => {
            if (resultPromise.err === null && resultPromise.data) {
                if (filter) {
                    setParents(sortHumanReadable(filter(resultPromise.data.Items), 'name'));
                }
                else {
                    setParents(sortHumanReadable(resultPromise.data.Items, 'name'));
                }
            }
            else {
                setParents([]);
            }
        });
    }, []);
    useEffect(() => {
        if (selectedContext && selected) {
            setParamsInParent([{ key: supportKey, value: `${selectedContext.id}`, predicate: ComparisonType.EQUALS }], index);
        }
        else {
            setParamsInParent(undefined, index);
        }
    }, [selectedContext, selected]);
    const changeParent = (e) => {
        setSelectedContext(parents?.find((parent) => parent.id === e.target.value));
    };
    return (_jsxs(Toolbar, { children: [children, _jsx("div", { style: { flexGrow: 1 }, children: _jsxs(FormControl, { fullWidth: true, children: [_jsx(InputLabel, { size: "small", id: "property-label", children: parents?.length === 0 ? 'N/A' : '' }), _jsx(Select, { disabled: parents?.length === 0, value: selectedContext?.id, onChange: changeParent, onKeyDown: keyPress, size: "small", children: parents?.map((parent) => {
                                return _jsx(MenuItem, { value: parent.id, children: parent.name });
                            }) })] }) })] }));
};
